/* eslint-disable @typescript-eslint/no-unused-vars */
import Button from "@mui/material/Button";
import {
	useResetFreeGiftMutation,
	useSimulatePurchasesFreeGiftMutation
} from "redux/apis/clubFreeGift";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import SimulatePurchases from "./lib/SimulatePurchases";

interface ClubFreeGiftToolsProps {
	showSuccessDialog: (success: boolean, title: string) => Promise<void>;
}

const ClubFreeGiftTools = ({ showSuccessDialog }: ClubFreeGiftToolsProps) => {
	const [resetClubFreeGift, { isLoading: isResetLoading }] =
		useResetFreeGiftMutation();
	const { showErrorDialog } = useDialogModalRedux();

	const handleResetClubGift = async () => {
		await resetClubFreeGift({})
			.unwrap()
			.then(() => {
				showSuccessDialog(true, "Reset Club Free Gift");
			})
			.catch((error) => {
				showErrorDialog({
					data: {
						errorCode: error?.status?.toString(),
						errorMessage: error?.data?.error?.toString()
					}
				});
			});
	};

	return (
		<div>
			<>
				<div>
					<Button
						variant="outlined"
						onClick={handleResetClubGift}
						disabled={isResetLoading}
					>
						Reset Club Free Gift
					</Button>
					<br />
					<br />
					<SimulatePurchases />
				</div>
			</>
		</div>
	);
};

export default ClubFreeGiftTools;
